import { render, staticRenderFns } from "./investor_customer.vue?vue&type=template&id=46f18078&scoped=true&"
import script from "./investor_customer.vue?vue&type=script&lang=js&"
export * from "./investor_customer.vue?vue&type=script&lang=js&"
import style0 from "./investor_customer.vue?vue&type=style&index=0&id=46f18078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f18078",
  null
  
)

export default component.exports